module.exports = __webpack_public_path__ + "img/1_jeff_s.7235460e.png";